
const SearchTransactions = () => {

    return (<div className="header-top-padding">
        Search transactions
    </div>)
}

export default SearchTransactions;